<template lang='pug'>
  .fpui-dropdown-head(@click='toggle')
    slot
</template>

<script>

export default {
  methods: {
    toggle () {
      if (typeof this.$parent.toggle === 'function') {
        this.$parent.toggle()
      }
    }
  }
}
</script>

<style lang='less'>
  .fpui-dropdown-head {

  }
</style>
